import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'group',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `group`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `group/${id}`,
    method: 'get'
  })
}

/**
 * @param {Object} data
 * @param {String} data.name
 * @param {Number} data.company
 * @returns {Promise<Object>}
 */
export function add (data) {
  return request({
    url: 'group',
    method: 'post',
    data
  })
}

/**
 * @param {Number} id
 * @param {Object} data
 * @param {String} data.name
 * @param {Number} data.company
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `group/${id}`,
    method: 'patch',
    data
  })
}
